export default __webpack_public_path__ + "static/media/villa.e850c6f8.webp";